import { GetProfileTypes } from './profile.type';
import { IGetProfileAction } from './profile.interface';

export const getProfile = (): IGetProfileAction => ({
	type: GetProfileTypes.GET_PROFILE,
});
